export default __webpack_public_path__ + "maps-examples-camera-animators-960-5f83ffe6e0a09da4f96a0195ad6cf648.png";